<div class="dropdown-wrapper">
  <button type="button" class="without-border" (click)="toggleConfigurationFields($event)">
    <span i18n>Настройка полей</span>
      <app-icon *ngIf="isConfigurationOpen">expand_less</app-icon>
      <app-icon *ngIf="!isConfigurationOpen">expand_more</app-icon>
  </button>

  <div
    *ngIf="isConfigurationOpen"
    class="dropdown-form"
    (appClickOutside)="isConfigurationOpen = false"
    [ngStyle]="dropdownStyles">
      <form [formGroup]="form" *ngIf="page === 'claims'">
        <p i18n >Отмеченные поля отображаются в таблице</p>
        <fieldset formGroupName="claimColumns">
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'id')"
              formControlName="id"></app-check-box>
            <label i18n>Код требования</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'payerNumber')"
              formControlName="payerNumber"></app-check-box>
            <label i18n>Номер счета</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'invoiceDate')"
              formControlName="invoiceDate"></app-check-box>
            <label i18n>Выставлено</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'dueDate')"
              formControlName="dueDate"></app-check-box>
            <label i18n>Срок оплаты</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'fullName')"
              formControlName="fullName"></app-check-box>
            <label i18n>ФИО</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'sum')"
              formControlName="sum"></app-check-box>
            <label i18n>Сумма</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'paymentSum')"
              formControlName="paymentSum"></app-check-box>
            <label i18n>Сумма оплаты</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().claimColumns, 'description')"
              formControlName="description"></app-check-box>
            <label i18n>Описание</label>
          </div>
        </fieldset>
      </form>

      <form [formGroup]="form" *ngIf="page === 'payments'">
        <p i18n >Отмеченные поля отображаются в таблице</p>
        <fieldset formGroupName="paymentsColumns">
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'accountNumber')"
              formControlName="accountNumber"></app-check-box>
            <label i18n>Номер счета</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'bankCode')"
              formControlName="bankCode"></app-check-box>
            <label i18n>Код банка</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'paymentDocumentNumber')"
              formControlName="paymentDocumentNumber"></app-check-box>
            <label i18n>№ платежного документа</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'paymentDocumentDate')"
              formControlName="paymentDocumentDate"></app-check-box>
            <label i18n>Дата платежного документа</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'paymentDate')"
              formControlName="paymentDate"></app-check-box>
            <label i18n>Дата и время оплаты</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'paymentSum')"
              formControlName="paymentSum"></app-check-box>
            <label i18n>Сумма оплаты</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'commissionSum')"
              formControlName="commissionSum"></app-check-box>
            <label i18n>Сумма комиссии</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'transferSum')"
              formControlName="transferSum"></app-check-box>
            <label i18n>Сумма зачисления</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'refundAvailableSum')"
              formControlName="refundAvailableSum"></app-check-box>
            <label i18n>Доступная сумма для возврата</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'refundSum')"
              formControlName="refundSum"></app-check-box>
            <label i18n>Сумма фактического возврата</label>
          </div>

          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'fullName')"
              formControlName="fullName"></app-check-box>
            <label i18n>ФИО</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'address')"
              formControlName="address"></app-check-box>
            <label i18n>Адрес</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'description')"
              formControlName="description"></app-check-box>
            <label i18n>Описание</label>
          </div>

          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'claimId')"
              formControlName="claimId"></app-check-box>
            <label i18n>Код в системе</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'paymentId')"
              formControlName="paymentId"></app-check-box>
            <label i18n>Код платежа</label>
          </div>

          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'providerOperId')"
              formControlName="providerOperId"></app-check-box>
            <label i18n>ID платежа ЕРИП</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().paymentsColumns, 'authorizationType')"
              formControlName="authorizationType"></app-check-box>
            <label i18n>Способ авторизации суммы</label>
          </div>
        </fieldset>
      </form>

      <form
        [formGroup]="form"
        *ngIf="authorizationService.isSuper && page === 'users'">
        <p i18n >Отмеченные поля отображаются в таблице</p>
        <fieldset formGroupName="usersColumns">
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientName')"
              formControlName="clientName"></app-check-box>
            <label i18n>ФИО</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientLogin')"
              formControlName="clientLogin"></app-check-box>
            <label i18n>Логин</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientEmail')"
              formControlName="clientEmail"></app-check-box>
            <label i18n>E-mail</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientPhoneNumber')"
              formControlName="clientPhoneNumber"></app-check-box>
            <label i18n>Телефон</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientTypeDescription')"
              formControlName="clientTypeDescription"></app-check-box>
            <label i18n>Роль</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientSupplierName')"
              formControlName="clientSupplierName"></app-check-box>
            <label i18n>Организация</label>
          </div>

          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientBlocked')"
              formControlName="clientBlocked"></app-check-box>
            <label i18n>Признак блокировки</label>
          </div>
          <div>
            <app-check-box
              [class.event-none]="isLastFieldTrue(form.getRawValue().usersColumns, 'clientDateAdd')"
              formControlName="clientDateAdd"></app-check-box>
            <label i18n>Дата создания</label>
          </div>
        </fieldset>
      </form>
    </div>
</div>
